export default "<ion-content class=\"bg\">\n  <img src=\"../../../assets/img/logo-barutico-seah.png\">\n</ion-content>\n";